/* Chahal Agri Farms — Mobile Card Micro-Animations (v56)
 * Complements the section-level scroll reveal in chahal-custom.js with a
 * per-card staggered fade + gentle image zoom, MOBILE ONLY. Pairs with
 * chahal-mobile-redesign.css (.caf-reveal / .caf-in / --caf-delay).
 *
 * Fail-safe: a card is only hidden AFTER this script adds .caf-reveal to
 * it; an IntersectionObserver then adds .caf-in, and a 3s timeout
 * force-reveals anything left. If the script never runs, nothing hides.
 * Skipped on desktop and when the visitor prefers reduced motion.
 */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wired = false;

  function collect() {
    var targets = [];
    document.querySelectorAll('.resource-list--grid').forEach(function (grid) {
      grid.querySelectorAll('.resource-list__item').forEach(function (item, i) {
        targets.push({ el: item, delay: Math.min(i, 5) * 60 });
      });
    });
    document.querySelectorAll('.caf-ws__card').forEach(function (card, i) {
      targets.push({ el: card, delay: Math.min(i, 5) * 70 });
    });
    return targets;
  }

  function setup() {
    if (wired) return;
    if (!MOBILE.matches || reduce) return;
    if (!('IntersectionObserver' in window)) return;

    var targets = collect();
    if (!targets.length) return;
    wired = true;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          requestAnimationFrame(function () { e.target.classList.add('caf-in'); });
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (t) {
      t.el.style.setProperty('--caf-delay', t.delay + 'ms');
      t.el.classList.add('caf-reveal');
      requestAnimationFrame(function () { io.observe(t.el); });
    });

    setTimeout(function () {
      targets.forEach(function (t) { t.el.classList.add('caf-in'); });
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  setTimeout(setup, 1200);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('.caf-reveal').forEach(function (el) {
        el.classList.add('caf-in');
      });
    }
  });
})();
